import { root, id } from './content';

export const content = {
  ...root,
  id,
};
